const objectMap = (obj, fn) => Object.keys(obj).map(key => fn(obj[key], key));

const toArrayWithIds = obj => objectMap(obj, (v, k) => Object.assign({}, v, {id: k}));

export {
  objectMap,
  toArrayWithIds
};
